const audio = document.getElementById("audio");
const playPauseButton = document.getElementById("play-pause-button");

if (audio && playPauseButton) {

    playPauseButton.addEventListener("click", () => {
        if (audio.paused) {
            audio.play();
            playPauseButton.classList.add('podcast-teaser-button-pause');
            playPauseButton.setAttribute('aria-label', 'Pause');
        } else {
            audio.pause();
            playPauseButton.classList.remove('podcast-teaser-button-pause');
            playPauseButton.setAttribute('aria-label', 'Play');
        }
    });

    audio.addEventListener('ended', function() {
        // Audio has ended when this function is executed.
        playPauseButton.classList.remove('podcast-teaser-button-pause');
        playPauseButton.setAttribute('aria-label', 'Play');
    });
}
